import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

// Utility function to check if user is authenticated
const isUserAuthenticated = () => {
  const accessTokenGoogle = localStorage.getItem('accessTokenGoogle');
  const departmentAccessToken = localStorage.getItem('departmentAccessToken');
  const clientAccessTokenGoogle = localStorage.getItem('clientAccessTokenGoogle');

  return !!(accessTokenGoogle || departmentAccessToken || clientAccessTokenGoogle);
};

function Aboutus() {
  const isAuthenticated = isUserAuthenticated();

  return (
    <div className="min-h-screen flex flex-col">
      <div className="background-circle circle-3 z-0"></div>
      <div className="background-circle circle-4 z-0"></div>
      {isAuthenticated && <Navbar />}

      <div className="relative bg-[#CDA454] py-4 mb-6">

          <Link
            to="/portal/Dashboard"
            className="absolute pl-4 md:pl-28 top-1/2 -translate-y-1/2"
          >
            <svg
              className="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
          </Link>

        <h1 className="text-center font-semibold text-white md:text-2xl text-xl">
          About Us
        </h1>
      </div>

      <div className=" px-4 sm:px-6 py-8">
        {/* Content Container */}
        <div className="max-w-4xl mx-auto space-y-8">
          {/* Tagline */}
          <div>
            <p className="text-white/80 text-lg leading-relaxed">
              Managing 1,000+ cases is now easier with JURIDENT – the all-in-one LegalTech platform for lawyers, law firms, companies, and law students.
            </p>
            <p className="text-white/60 text-base leading-relaxed mt-2">
              JURIDENT is a software platform developed and owned by Valsco Technology Pvt. Ltd.
            </p>
          </div>

          {/* Vision Section */}
          <div>
            <h2 className="text-[#CDA454] text-2xl font-semibold mb-3">
              OUR VISION
            </h2>
            <p className="text-white/80 text-lg leading-relaxed">
              To transform the legal ecosystem by building a unified LegalTech platform where lawyers, organizations, clients, and law students can collaborate efficiently.
            </p>
            <p className="text-white/80 text-lg leading-relaxed mt-2">
              JURIDENT envisions a future where legal operations, especially high-volume case management, are streamlined through technology, making them faster, smarter, and more transparent.
            </p>
          </div>

          {/* Mission Section */}
          <div>
            <h2 className="text-[#CDA454] text-2xl font-semibold mb-3">
              OUR MISSION
            </h2>
            <p className="text-white/80 text-lg leading-relaxed">
              Our mission is to simplify legal workflows through AI-powered tools, enabling lawyers, law firms, and companies to manage cases, automate documentation, and improve communication.
            </p>
            <p className="text-white/80 text-lg leading-relaxed mt-2">
              We aim to reduce manual effort, increase productivity, and provide a scalable platform for both individual practitioners and organizations handling complex legal operations.
            </p>
          </div>

          {/* Goal Section */}
          <div>
            <h2 className="text-[#CDA454] text-2xl font-semibold mb-3">OUR GOAL</h2>
            <p className="text-white/80 text-lg leading-relaxed">
              JURIDENT aims to bridge the gap between legal practice and technology by offering a complete legal practice management platform.
            </p>
          </div>

          {/* For Lawyers & Law Firms */}
          <div>
            <h2 className="text-[#CDA454] text-2xl font-semibold mb-3">FOR LAWYERS & LAW FIRMS</h2>
            <ul className="text-white/80 text-lg leading-relaxed space-y-2 list-disc pl-6">
              <li>Manage cases, clients, and documents in one platform</li>
              <li>Track hearings, notes, and next hearing dates</li>
              <li>Automate legal document drafting using AI</li>
              <li>Add expenses and generate invoices for cases</li>
              <li>Collaborate with team members and juniors</li>
              <li>Handle multiple and high-volume cases efficiently</li>
            </ul>
          </div>

          {/* For Organizations & Clients */}
          <div>
            <h2 className="text-[#CDA454] text-2xl font-semibold mb-3">FOR ORGANIZATIONS & CLIENTS</h2>
            <ul className="text-white/80 text-lg leading-relaxed space-y-2 list-disc pl-6">
              <li>Track ongoing legal cases in real-time</li>
              <li>View case updates, hearing dates, and progress</li>
              <li>Monitor expenses added by lawyers</li>
              <li>Access invoices directly on the dashboard</li>
              <li>Manage multiple legal matters from one platform</li>
              <li>Communicate seamlessly with lawyers</li>
            </ul>
          </div>

          {/* Sync Section */}
          <div>
            <h2 className="text-[#CDA454] text-2xl font-semibold mb-3">REAL-TIME CASE & BILLING SYNCHRONIZATION</h2>
            <p className="text-white/80 text-lg leading-relaxed mb-4">
              JURIDENT enables complete synchronization between lawyers and clients for cases, expenses, and billing — all in one platform.
            </p>
            <div className="space-y-4">
              <div>
                <h3 className="text-[#CDA454] text-lg font-semibold">Case Updates</h3>
                <p className="text-white/80 text-base leading-relaxed">Lawyers can update case details, notes, and hearing dates, which are instantly visible on the client dashboard.</p>
              </div>
              <div>
                <h3 className="text-[#CDA454] text-lg font-semibold">Expense Tracking</h3>
                <p className="text-white/80 text-base leading-relaxed">Lawyers can add case-related expenses, allowing clients to track legal costs transparently.</p>
              </div>
              <div>
                <h3 className="text-[#CDA454] text-lg font-semibold">Invoice Generation</h3>
                <p className="text-white/80 text-base leading-relaxed">Raise invoices directly from the platform and share them with clients in real-time.</p>
              </div>
              <div>
                <h3 className="text-[#CDA454] text-lg font-semibold">Unified System</h3>
                <p className="text-white/80 text-base leading-relaxed">All updates are synchronized across lawyer and client dashboards for smooth workflow and communication.</p>
              </div>
            </div>
          </div>

          {/* Why Jurident */}
          <div>
            <h2 className="text-[#CDA454] text-2xl font-semibold mb-3">WHY JURIDENT</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-[#CDA454] text-lg font-semibold">All-in-One Platform</h3>
                <p className="text-white/80 text-base leading-relaxed">Manage cases, clients, billing, and communication in one place.</p>
              </div>
              <div>
                <h3 className="text-[#CDA454] text-lg font-semibold">Built for Scale</h3>
                <p className="text-white/80 text-base leading-relaxed">Designed for law firms and companies handling high-volume cases.</p>
              </div>
              <div>
                <h3 className="text-[#CDA454] text-lg font-semibold">AI Powered</h3>
                <p className="text-white/80 text-base leading-relaxed">Automate legal documentation and repetitive tasks efficiently.</p>
              </div>
              <div>
                <h3 className="text-[#CDA454] text-lg font-semibold">For Law Students</h3>
                <p className="text-white/80 text-base leading-relaxed">Access internships and gain real-world legal exposure.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Aboutus;
